// extracted by mini-css-extract-plugin
export var notificationHost = "_cq-0";